export class ArticleQueryParams {
    module?: string = 'ALL';
    product?: string = 'MEDIA';
}